import { ActiveScopeGroup } from "@bvhi/backend-api";
import { Chip, ChipProps } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface Props extends ChipProps {
  type: string;
}

export function ActiveScopeGroupChip({ type, size = "small", ...chipProps }: Props) {
  const { t } = useTranslation(["enums"]);

  const label = useMemo(() => {
    switch (type) {
      case ActiveScopeGroup.ORDER_INVOICE_READ:
        return t("enums:enums.active.scope.group.order.invoice.read");
      case ActiveScopeGroup.CATALOG_READ:
        return t("enums:enums.active.scope.group.catalog.read");
      case ActiveScopeGroup.SUPPLIER:
        return t("enums:enums.active.scope.group.supplier");
      case ActiveScopeGroup.ERP_SUPPLIER:
        return t("enums:enums.active.scope.group.erp.supplier");
      case ActiveScopeGroup.ORDER_DESPATCH_ADVICE_READ:
        return t("enums:enums.active.scope.group.order.dispatch.note.read");
      case ActiveScopeGroup.ORDER_OTHER_READ:
        return t("enums:enums.active.scope.group.order.other.read");
      case ActiveScopeGroup.ORDER_CREATE:
        return t("enums:enums.active.scope.group.order.create");
    }
    return "";
  }, [type, t]);

  return <Chip label={label} size={size} {...chipProps} />;
}
